import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicRadioAndCheckboxs } from "../../../../Constant";
import { BASIC_RADIO_CHECKBOX } from "../../../../Data/FormControl/CheckboxAndRadio";
import { SimpleCheckboxs } from "./SimpleCheckboxs";
import { SimpleRadio } from "./SimpleRadio";

const BasicRadioAndCheckbox = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicRadioAndCheckboxs} span={BASIC_RADIO_CHECKBOX} />
        <CardBody>
          <Row className="g-3">
            <SimpleCheckboxs />
            <SimpleRadio />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicRadioAndCheckbox;
